class OrderConflictModal extends HTMLElement {
  #abortController;

  constructor() {
    super();
    this.btn = this.querySelector('button');
  }

  connectedCallback() {
    this.#abortController =  new AbortController();
    const { signal } = this.#abortController;
    this.btn.addEventListener('click', () => this.dataset.show = 'false', { signal });
  }

  disconnectedCallback() {
    this.#abortController.abort()
    this.#abortController = null;
  }

}

customElements.define('order-conflict-modal', OrderConflictModal);